import React, { useEffect, useState } from 'react';

import clsx from 'clsx';
import { Link, useHistory } from 'react-router-dom';
import parse from 'html-react-parser';
import {
  Grid,
  ListItemText,
  Divider,
  Typography,
  makeStyles,
  List,
  ListItemAvatar,
  Avatar,
  ListItem,
  Button,
  IconButton,
  CircularProgress,
  ClickAwayListener,
} from '@material-ui/core';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { clearNotifications } from '../../actions/settings/notifications-actions';

import { useSharedState } from '../../StoreContext';
import { SettingIcon } from '../../constants';

export default function NotificationContent({
  isMainScreen,
  notifications,
  // tokenData,
  onclickNotification,
  setNotificationOpen,
}) {
  const [, dispatchAction] = useSharedState();
  const history = useHistory();
  const dispatch = useDispatch();
  const useStyles = makeStyles((theme) => ({
    root: {
      width: isMainScreen ? '80%' : '30rem',
      position: isMainScreen ? 'relative' : 'absolute',
      zIndex: !isMainScreen && '999',
      top: !isMainScreen && '70px',
      right: !isMainScreen && '0',
      boxShadow: !isMainScreen && '0 8px 30px rgba(161, 191, 218, 0.16)',
      padding: '25px 0',
      borderRadius: '15px',
      background: '#fff',
      marginTop: isMainScreen && '1.5rem',
      [theme.breakpoints.down('sm')]: {
        width: isMainScreen ? '100%' : '30rem',
      },
      [theme.breakpoints.down('xs')]: {
        width: isMainScreen ? '100%' : '93vw',
        right: !isMainScreen && '-4.5rem',
      },
    },
    notification__title: {
      fontWeight: 'bold',
      fontSize: isMainScreen ? '18px' : '20px',
      linHeight: '29px',
      color: '#171717',
      padding: '0 1.5rem',
    },
    primary__text: {
      color: '#29264A',
      fontSize: '14px',
      lineHeight: '19px',
    },
    secondary__text: {
      color: '#95989A',
      fontSize: '13px',
      lineHeight: '16px',
      width: isMainScreen ? '25rem' : '70%',
      textAlign: isMainScreen && 'right',
      paddingTop: '0.3rem',
    },
    avatar__size: {
      height: '54px',
      width: '54px',
      marginRight: '0.7rem',
    },
    listItem__spacing: {
      padding: '0.6rem 25px',
      background: 'rgba(105, 33, 196, 0.1)',
      '&:hover': {
        background: 'rgba(105, 33, 196, 0.2)',
      },
      '& .MuiListItemText-multiline': {
        display: isMainScreen && 'flex',
        width: isMainScreen && ' 100%',
        justifyContent: isMainScreen && 'space-between',
        alignItems: isMainScreen && 'center',
      },
    },
    notification__ul: {
      maxHeight: isMainScreen ? 'calc(100vh - 225px)' : '35vh',
      height: isMainScreen && 'calc(100vh - 225px)',
      overflowY: 'scroll',
    },
    is__read: {
      color: '#8F92A1',
    },
    background__highlight: {
      width: '93%',
      background: 'rgba(105, 33, 196, 0)',
      '&:hover': {
        background: 'rgba(236, 236, 238, 0.5)',
      },
    },
    space__bw: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      paddingBottom: '0.5rem',
    },
    icon__btn: {
      padding: '0',
      color: 'var(--color-secondary)',
      height: '34px',
      width: '34px',
      marginRight: '1.5rem',
    },
    main__btn: {
      textTransform: 'capitalize',
      marginLeft: '10px',
      fontSize: '13px',
      borderRadius: '100px',
      fontWeight: '500',
      marginRight: '1rem',
    },
    view__all__btn: {
      padding: '0.6rem 1rem',
      border: '1px solid var(--color-secondary)',
      color: 'var(--color-secondary)',
      background: 'transparent !important',
    },
    clear__all__btn: {
      width: '110px',
      height: '40px',
      background: 'rgba(105, 33, 196, 0.2) !important',
      color: 'var(--color-primary)',
    },
    disabled__btn: {
      color: '#6d7d8b !important',
      background: '#ececee !important',
    },
    all__count: {
      background: 'rgba(109, 125, 139, 0.2)',
      color: '#6D7D8B',
      fontSize: '14px',
      fontWeight: '500',
      padding: '5px',
      borderRadius: '5px',
      marginLeft: '1rem',
    },
  }));
  const classes = useStyles();
  const [clearLoading, setClearLoading] = useState(false);

  const headerData = {
    title: 'Notifications',
    link: '',
    id: '',
  };
  useEffect(() => {
    dispatchAction({
      type: 'layout',
      payload: { field: 'setHeader', value: isMainScreen && headerData },
    });
  }, []);
  const onClearNotifications = async () => {
    setClearLoading(true);
    await dispatch(clearNotifications());
    setClearLoading(false);
  };

  return (
    <>
      <ClickAwayListener
        onClickAway={() => !isMainScreen && setNotificationOpen(false)}
      >
        <Grid className={classes.root} container>
          <div className={classes.space__bw}>
            <Typography className={classes.notification__title}>
              {isMainScreen ? 'All Notifications' : 'Notifications'}
              {isMainScreen && (
                <span className={classes.all__count}>
                  {notifications?.length || 0}
                </span>
              )}
            </Typography>
            <div>
              {isMainScreen ? (
                <Button
                  onClick={() => {
                    onClearNotifications();
                  }}
                  disabled={notifications?.length < 1 || clearLoading}
                  className={clsx(
                    classes.main__btn,
                    classes.clear__all__btn,
                    (notifications?.length < 1 || clearLoading) &&
                      classes.disabled__btn,
                  )}
                >
                  Clear All
                  {clearLoading && (
                    <CircularProgress size={12} style={{ marginLeft: '5px' }} />
                  )}
                </Button>
              ) : (
                <Link
                  to='/notifications'
                  className={clsx(classes.main__btn, classes.view__all__btn)}
                >
                  View all
                </Link>
              )}
              <IconButton className={classes.icon__btn}>
                <SettingIcon onClick={() => history.push('/settings?tab=2')} />
              </IconButton>
            </div>
          </div>
          <Divider variant='middle' />

          <List className={classes.notification__ul}>
            {notifications?.map((not, i) => {
              const message = parse(not?.notifications?.message || '');
              //  (
              //   <>
              //     {tokenData?.coUserId === not?.notifications?.co_user?.id ? (
              //       <span className={classes.primary__text}>
              //         <b> You </b>
              //         {not?.notifications?.message}
              //       </span>
              //     ) : (
              //       <span>
              //         <b>{not?.notifications?.co_user?.name}</b>
              //         {not?.notifications?.message}
              //       </span>
              //     )}
              //   </>
              // );
              return (
                <ListItem
                  className={clsx(
                    classes.listItem__spacing,
                    not?.isView && classes.background__highlight,
                  )}
                  key={i++}
                  onClick={() => onclickNotification(not)}
                >
                  <ListItemAvatar>
                    <Avatar
                      alt='Bryan G. Daniel'
                      className={classes.avatar__size}
                    />
                  </ListItemAvatar>
                  <ListItemText
                    primary={message}
                    secondary={
                      moment(not?.notifications?.createdAt)
                        // .startOf('day')
                        .fromNow() === 'a few seconds ago'
                        ? 'just now'
                        : moment(not?.notifications?.createdAt)
                            // .startOf('day')
                            .fromNow()
                    }
                    classes={{
                      primary: clsx(
                        classes.primary__text,
                        not?.isView && classes.is__read,
                      ),
                      secondary: clsx(
                        classes.secondary__text,
                        not?.isView && classes.is__read,
                      ),
                    }}
                  />
                </ListItem>
              );
            })}
          </List>
        </Grid>
      </ClickAwayListener>
    </>
  );
}
